import { Badge } from '@chakra-ui/react'
import { defaultDateFrom } from 'BrokerTsLib/src/dtos'
import { useEffect } from 'react'

import { useApp } from '@/hooks/useApp'

import { Card, CardBody, CardTitle } from '../../../components/Card'
import { ConceptsList } from '../../../containers/concepts'
import { useAuth } from '../../../context/AuthContext'
import { useGetAll } from '../../../hooks/useInsuranceParams'

function ConceptsWidget() {
  const { user } = useAuth()!
  const { product } = useApp()
  const pageSize = 5

  const filter = {
    dateCreatedFrom: defaultDateFrom,
    listType: 1,
    pageSize: pageSize,
    pageIndex: 1
  }

  const { data, mutateAsync, isPending: isLoading } = useGetAll()
  const concepts = data?.data
  const items = concepts?.items ?? []

  useEffect(() => {
    if (!user?.id) return

    mutateAsync(filter)
  }, [user?.id, product])

  return (
    <Card>
      <CardTitle>
        Neuzavřené nabídky
        {!isLoading && items.length > 0 && <Badge>{items.length} / {concepts?.totalCount}</Badge>}
      </CardTitle>

      <CardBody sx={{ p: 0 }}>
        <ConceptsList concepts={items} loading={isLoading} />
      </CardBody>
    </Card>
  )
}

export default ConceptsWidget